<template>
  <v-card>
    <v-card-title>{{ displayContent }}</v-card-title>
    <v-progress-linear indeterminate />
  </v-card>
</template>

<script>
export default {
  name: 'loader-view',
  props: {
    content: {
      type: String,
      default: null,
    },
  },
  computed: {
    displayContent() {
      return this.content || this.$t('common.pleaseWait');
    },
  },
};
</script>

<style></style>
